
export default function IconUpdownFilter() {
  return (
    <svg
    className="datafilter"
      width="25"
      height="20"
      cursor = "pointer"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.19194 17.8081C8.07473 17.6908 7.91576 17.625 7.75 17.625C7.58424 17.625 7.42527 17.6908 7.30806 17.8081C7.19085 17.9253 7.125 18.0842 7.125 18.25C7.125 18.4158 7.19085 18.5747 7.30806 18.6919L9.80806 21.1919C9.92527 21.3092 10.0842 21.375 10.25 21.375C10.4158 21.375 10.5747 21.3092 10.6919 21.1919L13.1917 18.6922L13.1919 18.6919C13.3092 18.5747 13.375 18.4158 13.375 18.25C13.375 18.0842 13.3092 17.9253 13.1919 17.8081C13.0747 17.6908 12.9158 17.625 12.75 17.625C12.5842 17.625 12.4253 17.6908 12.3081 17.8081L12.3078 17.8083L10.25 19.8661L8.19194 17.8081Z"
        fill="#fff"
      />
      <path
        d="M9.625 8.25V20.75C9.625 21.0952 9.90482 21.375 10.25 21.375C10.5952 21.375 10.875 21.0952 10.875 20.75V8.25C10.875 7.90482 10.5952 7.625 10.25 7.625C9.90482 7.625 9.625 7.90482 9.625 8.25Z"
        fill="#fff"
      />
      <path
        d="M19.8077 11.1916L19.8081 11.1919C19.9253 11.3092 20.0842 11.375 20.25 11.375C20.4158 11.375 20.5747 11.3092 20.6919 11.1919C20.8092 11.0747 20.875 10.9158 20.875 10.75C20.875 10.5842 20.8092 10.4253 20.6919 10.3081L18.1919 7.80806C18.0747 7.69085 17.9158 7.625 17.75 7.625C17.5842 7.625 17.4253 7.69085 17.3081 7.80806L14.8081 10.3081C14.6908 10.4253 14.625 10.5842 14.625 10.75C14.625 10.76 14.6252 10.77 14.6257 10.78C14.6332 10.9352 14.6982 11.0821 14.8081 11.1919C14.9253 11.3092 15.0842 11.375 15.25 11.375C15.4158 11.375 15.5747 11.3092 15.6919 11.1919L15.6922 11.1917L17.75 9.13388L19.8077 11.1916Z"
        fill="#fff"
      />
      <path
        d="M18.375 20.75V8.25C18.375 7.90482 18.0952 7.625 17.75 7.625C17.4048 7.625 17.125 7.90482 17.125 8.25V20.75C17.125 21.0952 17.4048 21.375 17.75 21.375C18.0952 21.375 18.375 21.0952 18.375 20.75Z"
        fill="#fff"
      />
    </svg>
  );
}
